// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"150":"wp-content/themes/mibarrio-theme/public/styles/app","254":"wp-content/themes/mibarrio-theme/public/styles/editor","650":"wp-content/themes/mibarrio-theme/public/styles/admin"}[chunkId] + ".css";
};